export default function Icon({ name, className = "w-5 h-5" }) {
  const common = {
    className,
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor",
    strokeWidth: 1.8,
  };

  if (name === "spark")
    return (
      <svg {...common}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M12 2l1.5 5.5L19 9l-5.5 1.5L12 16l-1.5-5.5L5 9l5.5-1.5L12 2z" />
        <path strokeLinecap="round" strokeLinejoin="round" d="M19 14l.9 3.1L23 18l-3.1.9L19 22l-.9-3.1L15 18l3.1-.9L19 14z" />
      </svg>
    );

  if (name === "users")
    return (
      <svg {...common}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M17 20h5v-2a4 4 0 00-4-4h-1m-4 6H2v-2a4 4 0 014-4h7a4 4 0 014 4v2z" />
        <path strokeLinecap="round" strokeLinejoin="round" d="M9 10a4 4 0 100-8 4 4 0 000 8z" />
        <path strokeLinecap="round" strokeLinejoin="round" d="M19 7a3 3 0 11-6 0 3 3 0 016 0z" />
      </svg>
    );

  if (name === "refresh")
    return (
      <svg {...common}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M4 4v6h6M20 20v-6h-6" />
        <path strokeLinecap="round" strokeLinejoin="round" d="M20 14a8 8 0 00-14.5-4M4 10a8 8 0 0014.5 4" />
      </svg>
    );

  if (name === "search")
    return (
      <svg {...common}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M21 21l-4.3-4.3m1.8-5.2a7 7 0 11-14 0 7 7 0 0114 0z" />
      </svg>
    );

  if (name === "plus")
    return (
      <svg {...common}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M12 4v16m8-8H4" />
      </svg>
    );

  if (name === "trash")
    return (
      <svg {...common}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6M9 7h6m2 0H7m3-3h4a1 1 0 011 1v2H9V5a1 1 0 011-1z" />
      </svg>
    );

  if (name === "shield")
    return (
      <svg {...common}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
      </svg>
    );

  if (name === "eye")
    return (
      <svg {...common}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M2.5 12s3.5-7 9.5-7 9.5 7 9.5 7-3.5 7-9.5 7-9.5-7-9.5-7z" />
        <path strokeLinecap="round" strokeLinejoin="round" d="M12 15a3 3 0 100-6 3 3 0 000 6z" />
      </svg>
    );

  if (name === "eye-off")
    return (
      <svg {...common}>
        <path strokeLinecap="round" strokeLinejoin="round" d="M3 3l18 18" />
        <path strokeLinecap="round" strokeLinejoin="round" d="M10.7 10.7A2.99 2.99 0 0012 15a3 3 0 001.9-.7" />
        <path strokeLinecap="round" strokeLinejoin="round" d="M9.9 5.3A10.6 10.6 0 0112 5c6 0 9.5 7 9.5 7a17.3 17.3 0 01-3.2 4.4" />
        <path strokeLinecap="round" strokeLinejoin="round" d="M6.3 6.3C3.7 8.3 2.5 12 2.5 12s3.5 7 9.5 7c1.2 0 2.3-.2 3.4-.6" />
      </svg>
    );

  return null;
}
